import { useState } from 'react';

const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        if (typeof window === "undefined") {
            return defaultValue;
        }
        try {
            return JSON.parse(localStorage.getItem(key) || String(defaultValue));
        }
        catch (error) {
            return defaultValue;
        }
    });
    const updateValue = (val) => {
        setValue(val);
        if (typeof window !== "undefined") {
            localStorage.setItem(key, JSON.stringify(val));
        }
    };
    return [value, updateValue];
};

export { useLocalStorage };
//# sourceMappingURL=useLocalStorage.js.map
